import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/page_example',
  component: Layout,
  name: 'pageExample',
  meta: {
    title: '页面模板',
    icon: 'ep:monitor',
    code: '0103',
  },
  children: [
    {
      path: 'tfctb',
      name: 'pageExampleBasicTfctb',
      component: () => import('@/views/page_basic_example/page_tfctb/index.vue'),
      meta: {
        title: '头部主表',
        code: '010301',
      },
    },
    {
      path: 'ltrrtb',
      name: 'pageExampleBasicLtrrtb',
      component: () => import('@/views/page_basic_example/page_ltrrtb/index.vue'),
      meta: {
        title: '左树右表',
        code: '010302',
      },
    },
    {
      path: 'ltbrtb',
      name: 'pageExampleBasicLtbrtb',
      component: () => import('@/views/page_basic_example/page_ltbrtb/index.vue'),
      meta: {
        title: '左表右表',
        code: '010303',
      },
    },
    {
      path: 'ldatertb',
      name: 'pageExampleBasicLdatertb',
      component: () => import('@/views/page_basic_example/page_ldatertb/index.vue'),
      meta: {
        title: '左日历右表',
        code: '010304',
      },
    },
    {
      path: 'menu',
      name: 'pageExampleBasicMenu',
      component: () => import('@/views/system/menu/get_menu_list/index.vue'),
      meta: {
        title: '菜单管理',
        code: '010305',
      },
    },
    {
      path: 'edit',
      name: 'pageExampleBasicMenuedit',
      component: () => import('@/views/system/menu/get_function_info/index.vue'),
      meta: {
        title: '编辑',
        code: '010306',
      },
    },
    {
      path: 'edit2',
      name: 'pageExampleBasicMenuedit2',
      component: () => import('@/views/system/menu/get_module_info/index.vue'),
      meta: {
        title: '编辑',
        code: '010307',
      },
    },
  ],
}

export default routes
